import { type ReactNode } from 'react';
import { Info } from '@material-ui/icons';
import { Tooltip } from '@material-ui/core';
import makeStyles from '@material-ui/styles/makeStyles';
import { whiteColor } from 'assets/jss/material-dashboard-pro-react';

const useStyles = makeStyles({
  tooltip: {
    maxWidth: '300px',
    color: whiteColor,
  },
  info: {
    marginLeft: '5px',
    color: 'grey',
    fontSize: '20px',
  },
  childrenWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
});

type InfoIconTooltipProps = {
  title: ReactNode;
  children?: ReactNode;
};

const InfoIconTooltip = ({ children, title }: InfoIconTooltipProps) => {
  const classes = useStyles();

  const infoIcon = <Info className={classes.info} />;

  return (
    <Tooltip
      classes={{ tooltip: classes.tooltip }}
      title={title}
      placement="right"
    >
      {children ? (
        <span className={classes.childrenWrapper}>
          {children}
          {infoIcon}
        </span>
      ) : (
        infoIcon
      )}
    </Tooltip>
  );
};

export default InfoIconTooltip;
